import React, {Dispatch, ReactNode, SetStateAction, useContext} from 'react'
import {HandleCreateMessageParams, MessageContent, MessageModel} from '../definitions'
import {CHATBOT_MODE, ChatbotMode} from '../definitions/type'

type ChatbotContextType = {
  messages: MessageModel<MessageContent>[]
  setMessages: Dispatch<SetStateAction<MessageModel<MessageContent>[]>>
  addMessage: (message: Partial<MessageModel<MessageContent>>) => void
  addMessages: (messages: Partial<MessageModel<MessageContent>>[]) => void
  putMessage: (id: number | string, message: Partial<MessageModel<MessageContent>>) => void
  patchMessage: (id: number | string, message: Partial<MessageModel<MessageContent>>) => void
  findMessageById: (id: number | string) => MessageModel<MessageContent> | undefined
  setMode: (mode: ChatbotMode) => void
  mode: ChatbotMode
  isSendingMessage: boolean
  isMessageResponded: boolean
  handleCreateMessage: (params: HandleCreateMessageParams) => void
  disabledUserAction: boolean
}

const DEFAULT_VALUE: ChatbotContextType = {
  messages: [],
  setMessages: () => {},
  addMessage: () => {},
  addMessages: () => {},
  putMessage: () => {},
  patchMessage: () => {},
  findMessageById: () => undefined,
  setMode: () => {},
  mode: CHATBOT_MODE.DEFAULT,
  isSendingMessage: false,
  isMessageResponded: true,
  handleCreateMessage: () => {},
  disabledUserAction: false,
}

export const ChatbotContext = React.createContext<ChatbotContextType>(DEFAULT_VALUE)

export const ChatbotContextProvider = ({
  value,
  children,
}: {
  value: ChatbotContextType
  children: ReactNode
}) => {
  return <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>
}

export const useChatbotContext = () => {
  const chatbotContext = useContext(ChatbotContext)

  if (!chatbotContext) {
    throw new Error('Invalid Chatbot Context')
  }

  return chatbotContext
}
